import apiInstance from './apiInstance';
import { handleUnauth } from './appService';

async function getApplications() {
  try {
    const res = await apiInstance.get('/applications');
    return res.data;
  } catch (error) {
    return handleUnauth(error);
  }
}
async function getRemovedApplications() {
  try {
    const res = await apiInstance.get('/applications/removed');
    return res.data;
  } catch (error) {
    return handleUnauth(error);
  }
}

async function getApplication(id) {
  try {
    const res = await apiInstance.get(`/applications/${id}`);
    return res.data;
  } catch (error) {
    return handleUnauth(error);
  }
}

async function getSwapTree(applicationId) {
  try {
    const { data } = await apiInstance.get(`/swapTree/render/${applicationId}`);
    return data;
  } catch (error) {
    return null;
  }
}

async function getMapCoordinates(applicationId) {
  const { data } = await apiInstance.get(`/map/${applicationId}`);
  return data;
}

async function removeApplication(applicationId, reason = '') {
  try {
    const res = await apiInstance.post(
      `/applications/${applicationId}/remove`,
      {
        reason
      }
    );
    return res.status === 200;
  } catch (error) {
    return null;
  }
}

async function rejectApplication(applicationId, note) {
  try {
    const res = await apiInstance.post(
      `/applications/${applicationId}/reject`,
      {
        note
      }
    );
    return res.status === 200;
  } catch (error) {
    return null;
  }
}

async function abortApplication(applicationId) {
  try {
    const res = await apiInstance.post(`/applications/${applicationId}/abort`);
    return res.status === 200;
  } catch (error) {
    return null;
  }
}

async function cancelDeleteApplication(applicationId) {
  try {
    const res = await apiInstance.post(
      `/applications/${applicationId}/abort-remove`
    );
    return res.data;
  } catch (error) {
    return null;
  }
}

async function approveApplication(applicationId) {
  try {
    const res = await apiInstance.post(
      `/applications/${applicationId}/approve`
    );
    return res.status === 200;
  } catch (error) {
    return null;
  }
}

async function restoreApplication(applicationId) {
  await apiInstance.post(`/applications/${applicationId}/restore`);
}

async function getDocuments(applicationId) {
  const res = await apiInstance.get(`/documents/${applicationId}`);
  return res.data;
}

async function getLbPreviewLink(applicationId, propositionId) {
  try {
    const res = await apiInstance.get(
      `/lb/preview/${applicationId}/${propositionId}`
    );
    return res.data;
  } catch (error) {
    return null;
  }
}

async function mergeDocuments({
  applicationId,
  documentIds = [],
  landlordDocs = [],
  mergedDocumentIds = [],
  scrive = false,
  abortController
}) {
  const res = await apiInstance.post(
    `/documents/pdf/merge/${applicationId}`,
    {
      landlordDocs,
      documentIds,
      mergedDocumentIds,
      scrive
    },
    { signal: abortController?.signal, responseType: 'blob' }
  );
  return res.data;
}

async function getSwapGeography() {
  const res = await apiInstance.get('statistics/swap-geography');
  return res.data;
}

async function getAnalyticsOverview() {
  const res = await apiInstance.get('statistics/analytics');
  return res.data;
}

async function getFilteringStats(type = 'ba') {
  const res = await apiInstance.get(`statistics/filtering?type=${type}`);
  return res.data;
}

async function generalStatistics() {
  return apiInstance.get(`statistics/bytesansokan`);
}

async function swapTypesStatistics() {
  return apiInstance.get(`statistics/bytesansokan-swap-types`);
}

async function userStatsStatistics() {
  return apiInstance.get(`statistics/bytesansokan-user-stats`);
}

async function getDashboardStatistics() {
  const res = await apiInstance.get('statistics/dashboard');
  return res.data;
}

async function getDashboardAnalytics() {
  const res = await apiInstance.get('analytics/dashboard');
  return res.data;
}

export {
  approveApplication,
  restoreApplication,
  rejectApplication,
  getApplication,
  getApplications,
  getRemovedApplications,
  getSwapTree,
  getDocuments,
  getLbPreviewLink,
  getMapCoordinates,
  mergeDocuments,
  generalStatistics,
  swapTypesStatistics,
  userStatsStatistics,
  removeApplication,
  abortApplication,
  cancelDeleteApplication,
  getSwapGeography,
  getAnalyticsOverview,
  getFilteringStats,
  getDashboardStatistics,
  getDashboardAnalytics
};
